module.exports = __webpack_public_path__ + "img/DUOPLES_Logo.8a1c9d34.jpg";